import React from 'react';

export default function ShopSearchRecoveryPanel({ recovery, onExpandRadius, onIncludeGeneral, onShowAll }) {
  if (!recovery) return null;

  const handleAction = (action) => {
    if (action.type === 'expand_radius') onExpandRadius?.(action.radiusMiles);
    if (action.type === 'include_general') onIncludeGeneral?.();
    if (action.type === 'show_all') onShowAll?.();
  };

  return (
    <div className="rounded-xl border border-amber-200 dark:border-amber-700 bg-amber-50 dark:bg-gray-900 px-3 py-3 text-sm text-amber-950 dark:text-amber-200" role="status">
      <p className="font-semibold">{recovery.title}</p>
      <p className="mt-1">{recovery.detail}</p>
      {recovery.reason && recovery.reason !== recovery.detail ? (
        <p className="mt-1 text-xs text-amber-900 dark:text-amber-200">Reason: {recovery.reason}</p>
      ) : null}
      {recovery.actions?.length ? (
        <div className="mt-3 flex flex-wrap gap-2">
          {recovery.actions.map((action) => (
            <button
              key={`${action.type}-${action.radiusMiles || action.label}`}
              type="button"
              onClick={() => handleAction(action)}
              className="rounded-xl border border-amber-300 dark:border-amber-700 bg-white dark:bg-gray-800 px-3 py-1.5 text-xs font-medium text-amber-950 dark:text-amber-200 hover:bg-amber-100 dark:hover:bg-gray-700"
            >
              {action.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
